<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen">
    <template #left>
      <div class="brand-panel h-full flex items-center justify-center" style="width: 42vw">
        <div class="brand-disc flex items-center justify-center">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="brand-lockup" v-html="mainLogo" />
        </div>
      </div>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px] px-4">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-col items-center justify-center mx-auto max-w-[420px]">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="brand-lockup-sm mb-6" v-html="mainLogo" />
          <div class="w-full">
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import mainLogo from '../assets/main_logo.svg?raw'

const breakpoint = useBreakpoint()
</script>

<style scoped>
.brand-panel {
  /* Dark "Ink" panel with subtle brand glows: green from the bottom-left,
     a soft red from the top-right, over a deep ink-green gradient. */
  background:
    radial-gradient(circle at 78% 20%, rgba(226, 58, 78, 0.18) 0%, transparent 45%),
    radial-gradient(circle at 18% 82%, rgba(46, 158, 91, 0.22) 0%, transparent 48%),
    linear-gradient(160deg, #1f2d24 0%, #16211b 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.06);
}
/* White disc (softly green-tinted, with a green ring) so the logo lifts off
   the dark panel instead of sitting on plain white. */
.brand-disc {
  width: min(58%, 380px);
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  padding: clamp(2rem, 5vw, 3.25rem);
  background: radial-gradient(circle at 50% 42%, #ffffff 0%, #eef6f0 60%, #e0efe6 100%);
  border: 2px solid rgba(46, 158, 91, 0.4);
  box-shadow:
    0 18px 50px rgba(0, 0, 0, 0.35),
    inset 0 0 0 6px rgba(255, 255, 255, 0.6);
}
.brand-lockup {
  width: 100%;
}
.brand-lockup-sm {
  width: min(80%, 300px);
}
.brand-lockup :deep(svg),
.brand-lockup-sm :deep(svg) {
  width: 100%;
  height: auto;
  display: block;
}
</style>
